var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75107 12.2626L13.6795 7.28224C14.107 6.85006 14.107 6.1495 13.6795 5.71732L8.75107 0.736994C8.32133 0.317571 7.63825 0.323568 7.21579 0.750475C6.79333 1.17738 6.78739 1.86766 7.20245 2.30192L9.7937 4.92157C9.8699 5.001 9.89196 5.11866 9.84978 5.22075C9.80761 5.32283 9.70932 5.38972 9.59985 5.39083H1.09521C0.49034 5.39083 0 5.88633 0 6.49757C0 7.1088 0.49034 7.60431 1.09521 7.60431H9.59985C9.71075 7.6041 9.81081 7.67152 9.85327 7.77504C9.89574 7.87856 9.87222 7.99774 9.7937 8.07688L7.20245 10.6976C6.78739 11.1319 6.79333 11.8222 7.21579 12.2491C7.63825 12.676 8.32133 12.682 8.75107 12.2626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmArrow);
export default __webpack_public_path__ + "static/media/confirm-arrow.c2b78914d346859a3ab7386916183b2c.svg";
export { ForwardRef as ReactComponent };